import { complement } from "ramda";
import fileDropZone from "../fileDropZone";
import { ATTR_DISABLE_EDITING } from "./view/view.attribute.names";
import { hasYesAttributeJq } from "./view/viewNodeAccessors";

const DRAG_CLASS = 'dragging';

// jQuery -> Boolean
const canDrop = complement(hasYesAttributeJq(ATTR_DISABLE_EDITING));

const fileDropWatcher = (options) => {
    if (!fileDropZone.isSupported()) {
        return;
    }

    fileDropZone({
        container: options.container,
        selector: '.xdFileAttachment, .fv-image-placeholder, .xdInlinePicture',
        onDragStart: function ($el) {
            if (canDrop($el)) {
                $el.addClass(DRAG_CLASS);
            }
        },
        onDragEnd: function ($el) {
            $el.removeClass(DRAG_CLASS);
        },
        onDrop: (evt) => {
            if (options.onDrop && canDrop(evt.target)) {
                options.onDrop(evt);
            }
        },
    });
}

export default fileDropWatcher;